import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgAngleUp = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m12.55 5.24 11.21 11.21a.75.75 0 0 1 0 1.1l-1.2 1.21A.82.82 0 0 1 22 19a.86.86 0 0 1-.55-.24L12 9.31l-9.45 9.45A.84.84 0 0 1 2 19a.86.86 0 0 1-.56-.24l-1.2-1.21a.75.75 0 0 1 0-1.1L11.45 5.24a.75.75 0 0 1 1.1 0"
    }));
export default SvgAngleUp;
